var smoothScrollInit;

(function($){
		
	const selectors = {
		link: 'a[href^="#"]:not([href="#"]):not([data-ignore-scroll])',
	}
	
	smoothScrollInit = function(){
		$(selectors.link).each((i, el) => {
			new Link(el);
		});
	}
	
	class Link {
		constructor(element){
			this.$link = $(element);
			
			this.init();
			this.bind();
			
		}
		init(){
			this.$target = $( this.$link.attr('href') );
			this.animationTime = 700;
		}
		bind(){
			this.$link.click( (e) => { e.preventDefault(); this.linkClicked(); })
		}
		
		
		
		linkClicked(){
			if( ! this.$target.length ) return;
			
			var offTop = this.$target.offset().top;
			
			if( document.headerHeightScrolled && this.$link.attr('data-ignore-header') === undefined ){ 
				offTop -= document.headerHeightScrolled;
			}
			
			$(window).trigger('smooth-scroll-started');
			
			$('html, body').stop().animate( {scrollTop: offTop}, this.animationTime, function(){
				$(window).trigger('smooth-scroll-ended');
			} );
			
		}
		
	}
})(jQuery);
	
	
export default smoothScrollInit;